import { memo, useCallback } from 'react';

import { Button, CopyText, Flex, Heading, Label, Text } from '@/components/core';
import { HowToGuide } from '@/components/flow';
import { ZapierLogo } from '@/components/logos';
import { toAppClientId, useGetAppClient, useListAppClients } from '@/hooks/api';
import { useTriggerStore } from '@/store';

export type TriggerZapierConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const ITriggerZapierConfiguration = ({}: TriggerZapierConfigurationProps) => {
  const action = useTriggerStore((state) => state.action);
  const { data: appClients } = useListAppClients();
  const appClientWithSecret = appClients?.data?.find((appClient) => appClient.hasSecret);

  const { data: appClient } = useGetAppClient(toAppClientId(appClientWithSecret?.appClientId), {
    refetchInterval: (query) => (!query.state.data?.clientSecret ? 2000 : undefined),
  });

  const onSetupClicked = useCallback(() => {
    window.open('https://docs.cradl.ai/integrations/zapier/trigger', '_blank');
  }, []);

  return (
    <Flex col className="gap-md p-md grow">
      <Flex col className="gap-sm">
        <Label>Account</Label>

        <Flex className="p-sm gap-sm bg-gray-25 items-center rounded-md border-1 border-gray-100">
          <ZapierLogo size="xl" />

          <Heading className="grow">Zapier</Heading>

          <Button variant="secondary" onPress={onSetupClicked}>
            <Text>Setup</Text>
          </Button>
        </Flex>
      </Flex>

      <Flex variant="plain" col className="p-md gap-4 rounded-lg border-1 border-gray-100 bg-white shadow-xs">
        <Flex col className="gap-xs">
          <Label>Client ID</Label>
          <CopyText value={appClient?.clientId} />
        </Flex>

        <Flex col className="gap-xs">
          <Label>Client Secret</Label>
          <CopyText isSensitive value={appClient?.clientSecret} />
        </Flex>
      </Flex>

      <div className="grow" />

      <HowToGuide actionId={action?.actionId} />
    </Flex>
  );
};

export const TriggerZapierConfiguration = memo(ITriggerZapierConfiguration) as typeof ITriggerZapierConfiguration;
